import { CSSProperties } from 'styled-components'
import { ESplitType, formatDate } from '../../util/dateFormat'
import { IBookNumerology } from './const'
import { Window, WindowBoxCss } from './index.css'
interface IProps {
	style?: CSSProperties
	item: {
		content: string | number
		image: string
		info: {
			title: string
			subTitle: string
			date?: string
		}
	}
	type: 'book' | 'human'
}
export default function WindowBox({ item, style, type }: IProps) {
	return (
		<WindowBoxCss style={style}>
			<Window
				content={item.content ?? ''}
				image={item.image ?? ''}
				type={type}
			/>
			<div className='info'>
				<p>{item.info.title ?? ''}</p>
				{item.info.date ? (
					<span>{formatDate(item.info.date, ESplitType['/'])}</span>
				) : null}
				<span>{item.info.subTitle ?? ''}</span>
			</div>
		</WindowBoxCss>
	)
}
